import React       from 'react';
import HiddenInput from 'pu-react/components/HiddenInput';

const ColumnSelected = (props) => {
  const name = 'column_selected';
  // let value = props.parameters.get(name);
  let value = props.parameters.get ? props.parameters.get(name) : props.parameters[name];
  if (value !== undefined && typeof value === 'number') {
    value = value.toString();
  }
  return (<HiddenInput name={name} value={value === undefined ? '' : value} />);
};

export default ColumnSelected;
